import { Offer } from '~/store/ducks/offers/types'
import api from './api'

const url = '/campaigns'

export function createOffer(offer: Offer) {
  return api.post(url, offer)
}
